/* eslint-disable linebreak-style */
import animationInit from '../utils/animation';
import { postData } from '../utils/klaviyo';

export default (element) => {
  const init = () => {
    element.toggleTarget = element.querySelectorAll('[data-accordion-toggle]');
    element.emailInput = element.querySelector('[name="contact[email]"]');
    element.emailBtn = document.getElementById('Newsletterfield--button');
    element.newsletterForm = document.getElementById('ContactFooter');
    element.smsSignupForm = document.getElementById('sms-form--footer');
    element.smsSignupInput = document.getElementById('sms-sign--footer');
    element.smsErrorMessage = document.getElementById('sms-error-message');
    element.smsSuccessMessage = document.getElementById('sms-success-message');
    element.smsPostErrorMessage = document.getElementById(
      'sms-post-error-message',
    );
    element.newsletterPostErrorMessage = document.getElementById(
      'newsletter-post-error-message',
    );

    const validateEmail = (email) =>
      // eslint-disable-next-line no-useless-escape
      /^[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(
        email,
      );

    const updateLiveRegion = (liveRegion, errorMessage) => {
      liveRegion.setAttribute('aria-live', 'assertive');
      liveRegion.setAttribute('role', 'alert');
      liveRegion.style.position = 'absolute';
      liveRegion.style.width = '1px';
      liveRegion.style.height = '1px';
      liveRegion.style.margin = '-1px';
      liveRegion.style.border = '0';
      liveRegion.style.padding = '0';
      liveRegion.style.clip = 'rect(0 0 0 0)';
      liveRegion.style.overflow = 'hidden';
      liveRegion.textContent = errorMessage;
    };

    const validateForm = () => {
      const formIsValid = validateEmail(element.emailInput.value);
      const errorMessage = element.querySelector('.form-error');
      if (!formIsValid) {
        element.newsletterForm.classList.add('invalid');
        element.emailInput.classList.add('input-invalid');

        errorMessage.classList.remove('hidden');
        errorMessage.textContent = '';

        // Create a hidden clone of the error message for VoiceOver to announce
        const liveRegion = document.createElement('span');
        updateLiveRegion(liveRegion, errorMessage.dataset.error);

        document.body.appendChild(liveRegion);
        setTimeout(() => {
          liveRegion.remove();
        }, 500);
        errorMessage.textContent = errorMessage.dataset.error;

        element.emailInput.focus();
        element.emailBtn.classList.add('button-invalid');
      } else {
        errorMessage.textContent = '';
        errorMessage.classList.add('hidden');

        element.newsletterForm.classList.remove('invalid');
        element.emailInput.classList.remove('input-invalid');
        element.emailBtn.classList.remove('button-invalid');
      }
      return formIsValid;
    };

    const initNewsletterForm = () => {
      if (element.newsletterForm) {
        element.newsletterForm.addEventListener('submit', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          element.newsletterPostErrorMessage.classList.add('hidden');
          if (validateForm()) {
            const listId = window.Benchmade.klaviyoEmailListId;
            if (listId === '') {
              /* eslint-disable-next-line no-console */
              console.warn('Klaviyo Email List ID is not set');
              return;
            }

            const formData = {
              profiles: [{ email: element.emailInput.value }],
            };

            postData(
              `/apps/service/klaviyo/api/v2/list/${listId}/subscribe`,
              formData,
            ).then(({ data, status }) => {
              if (!status) {
                element.newsletterPostErrorMessage.classList.remove('hidden');
                if (data.detail) {
                  element.newsletterPostErrorMessage.innerText = data.detail;
                }
              } else {
                element.newsletterForm.submit();
              }
            });
          }
        });
      }
    };

    const toggleAccordion = () => {
      element.toggleTarget.forEach((target) => {
        target.addEventListener('click', (event) => {
          event.preventDefault();
          target.dataset.accordionToggle =
            target.dataset.accordionToggle === 'true' ? 'false' : 'true';
        });
      });
    };

    const validatePhone = (inputValue) =>
      inputValue.length === 11 &&
      // eslint-disable-next-line no-useless-escape
      /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(inputValue);

    const initSmsSignupForm = () => {
      if (!element.smsSignupForm) return;

      const removeErrorState = () => {
        element.smsSignupInput.classList.remove(
          'input-invalid',
          '!text-accent-1',
        );
        element.smsErrorMessage.classList.add('hidden');
      };

      const addMask = (e) => {
        const x = e.target.value
          .replace(/\+1|\D/g, '')
          // .match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/);
          .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        e.target.value = `+1${x[1] ? `( ${x[1]} ) ` : ''}${x[2]}${
          x[3] ? ` - ${x[3]}` : ''
        }`;
      };

      element.smsSignupInput.addEventListener('input', (e) => {
        if (
          e.inputType !== 'deleteContentBackward' &&
          e.inputType !== 'deleteContentForward'
        ) {
          addMask(e);
        }
      });

      element.smsSignupInput.addEventListener('input', (e) => {
        // prevent user from deleting the +1
        if (e.inputType === 'deleteContentBackward') {
          if (e.target.value.length <= 2) {
            e.target.value = '+1';
          }
        }
      });

      element.smsSignupForm.addEventListener('submit', (event) => {
        event.preventDefault();
        const inputValue = element.smsSignupInput.value.replace(/\D/g, '');
        const isValid = inputValue ? validatePhone(inputValue) : false;

        if (!isValid) {
          element.smsSignupInput.classList.add(
            'input-invalid',
            '!text-accent-1',
          );
          element.smsErrorMessage.classList.remove('hidden');
          element.smsErrorMessage.textContent = '';

          // Create a hidden clone of the error message for VoiceOver to announce
          const liveRegion = document.createElement('span');
          updateLiveRegion(liveRegion, element.smsErrorMessage.dataset.error);

          document.body.appendChild(liveRegion);
          setTimeout(() => {
            liveRegion.remove();
          }, 500);
          element.smsErrorMessage.textContent =
            element.smsErrorMessage.dataset.error;

          element.smsSignupInput.addEventListener('keydown', removeErrorState);
          element.smsSignupInput.focus();
          return;
        }

        const listId = window.Benchmade.klaviyoSMSListId;
        if (listId === '') {
          /* eslint-disable-next-line no-console */
          console.warn('Klaviyo SMS List ID is not set');
          return;
        }

        const formData = {
          profiles: [{ phone_number: `+${inputValue}`, sms_consent: true }],
        };

        postData(
          `/apps/service/klaviyo/api/v2/list/${listId}/subscribe`,
          formData,
        ).then(({ data, status }) => {
          if (status !== 202) {
            element.smsPostErrorMessage.textContent = data.detail;
            element.smsPostErrorMessage.classList.remove('hidden');
          } else {
            element.smsSignupForm.classList.add('hidden');
            element.smsSuccessMessage.classList.remove('hidden');
            element.smsSignupInput.removeEventListener(
              'keydown',
              removeErrorState,
            );
            element.smsSignupInput.removeEventListener('input', (e) =>
              addMask(e),
            );
          }
        });
      });
    };

    const openOsanoConsentManagement = () => {
      const consentLink = document.querySelector('#consent-link');

      if (consentLink) {
        consentLink.addEventListener('click', () => {
          const osanoButton = document.querySelector('.osano-cm-widget');
          if (osanoButton) osanoButton.click();
        });
      }
    };

    toggleAccordion();
    initNewsletterForm();
    initSmsSignupForm();
    openOsanoConsentManagement();
  };

  init();
  animationInit();
};
